import { PricingData } from "models/interfaces";
import { createContext } from "react";

interface CustomProps {
  accountPlan: any;
  setAccountPlan: Function;
  featurePlanDetails: any;
  setFeaturePlanDetails: Function;
  selectedPlan: PricingData;
  setSelectedPlan: Function;
  isActivePlan: boolean;
  setIsActivePlan: Function;
}

export const MyPlanContext = createContext({} as CustomProps);
